// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { SAVE_IBAN_ENDPOINT } from './constants/financial-data.services.constants';

const saveIbanAccountService = async (iban: string): Promise<[null, Response]> =>
  apiUtils.post({ ...SAVE_IBAN_ENDPOINT, params: { iban } });

export { saveIbanAccountService };
